const InstagramIcon = ({ className, ...props }) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16 12C16 14.2102 14.2102 16 12 16C9.79198 16 8 14.2102 8 12C8 9.78982 9.79198 8 12 8C14.208 8.00217 15.9978 9.79198 16 12Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18 7.5C18 8.05255 17.5525 8.5 17 8.5C16.448 8.5 16 8.05255 16 7.5C16 6.94745 16.448 6.5 17 6.5C17.552 6.50054 17.9995 6.948 18 7.5Z"
                fill="currentColor"
            />
            <rect
                x="3.75"
                y="3.75"
                width="16.5"
                height="16.5"
                rx="5.25"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default InstagramIcon
